import { useIntl } from "react-intl";

import FormItem from "forms/fields/FormItem";
import parseDictionary from "forms/helpers/parseDictionary";
import type { FormControlType } from "types/formType";
import type { IProperty } from "types/jsonSchema";
import { predefinedFields } from "types/predefinedFields";
import { Fieldset } from "ui/Fieldset";
import { Select } from "ui/Select/Select";
import { FormField } from "uiShadcn/form";

export interface AvailabilityProps {
    control: FormControlType;
    availability: IProperty;
}

export default function Availability({ control, availability }: AvailabilityProps) {
    const { formatMessage } = useIntl();
    if (!availability) return null;

    const isRequired = availability.type === "integer";

    const options = parseDictionary({
        enumNames: availability?.["x-enumNames"] ?? [],
        enumValues: availability?.enum ?? [],
    });

    const dictionary = Object.entries(options).map(([value, label]) => ({
        key: value,
        value: label,
    }));

    return (
        <Fieldset title={formatMessage({ id: "availability" })}>
            <FormField
                control={control}
                name={predefinedFields.availability}
                render={({ field }) => (
                    <FormItem
                        label={formatMessage({
                            id: "when_you_can_start",
                        })}
                        required={isRequired}
                    >
                        <Select
                            ref={field.ref}
                            dataTestId="Select-availability"
                            defaultValue={field.value}
                            onValueChange={field.onChange}
                            required={isRequired}
                            options={dictionary}
                            placeholder={formatMessage({ id: "select" })}
                        />
                    </FormItem>
                )}
            />
        </Fieldset>
    );
}
